import React from 'react';

import { routes } from '../../../../constants';
import type { Alert } from '../../../NotificationAlert/NotificationAlert';
import MuiCardBase, { type MuiCardCommonProps } from '../MuiCardBase/MuiCardBase';

export interface VideoMuiCardProps extends MuiCardCommonProps {
	product?: {
		name: string;
		id: string;
	};
	isNewAddMenuButtonMenu?: boolean;
	onShowNotification?: (alert: Alert) => void;
}

const VideoMuiCard: React.FC<VideoMuiCardProps> = (props) => {
	const { isFirstElement = false, product, ...restProps } = props;

	return (
		<MuiCardBase
			{...restProps}
			isFirstElement={isFirstElement}
			contentType="video"
			link={
				product
					? {
							to: `/${routes.productPage.root}/${product.id}`,
							label: product.name,
							icon: 'book',
							hasTooltip: true,
						}
					: undefined
			}
		/>
	);
};

export default VideoMuiCard;
